import { isFunction } from 'lodash'
import React, { useRef, useState } from 'react'
import styled from 'styled-components'

type THtmlRadio = {
  name?: string
  value?: boolean | string
  option?: string
  onChange?: (val: string) => void
  disabled?: boolean
}
type TWrapper = {
  margin?: string
  hasFocus?: boolean
}
const Wrapper = styled.div<TWrapper>`
  & > label:before {
    cursor: pointer;
    margin: ${({ margin }) => margin};
    box-shadow: ${({ hasFocus }) =>
      hasFocus ? '0px 0px 3px 3px rgb(152 166 173 / 50%)' : 'none'};
  }

  & > label:after {
    cursor: pointer;
  }
`
// TODO: visually show if disabled (opacity, overlay)

const HtmlRadio = (props: THtmlRadio): React.ReactElement => {
  const { name, value, option = '', onChange, disabled } = props

  const ref = useRef<HTMLInputElement>()
  const [hasFocus, setHasFocus] = useState(false)

  const onChangeLocal = (): void => {
    if (disabled) {
      return
    }
    onChange && onChange(option)
    // force focus
    if (ref && ref.current && isFunction(ref.current.focus)) {
      ref.current.focus()
    }
  }

  const onFocus = (): void => setHasFocus(true)

  const onBlur = (): void => setHasFocus(false)

  return (
    <Wrapper className="radio" onClick={onChangeLocal} hasFocus={hasFocus}>
      <input
        disabled={disabled}
        ref={ref as React.LegacyRef<HTMLInputElement>}
        type="radio"
        name={name}
        checked={Boolean(value)}
        onChange={onChangeLocal}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <label />
    </Wrapper>
  )
}

export default HtmlRadio
